export default __webpack_public_path__ + "static/media/happy-family.d6a35224.jpg";